"use strict";
/**
 * Returns a list with stopwords for the English passive voice assessment.
 * @returns {Array} The list with stopwords.
 */

module.exports = function () {
    return ["to", "which", "who", "whom", "that", "whose", "after", "although", "as", "because", "before", "even if", "even though", "how", "if", "in order that", "inasmuch", "lest", "once", "provided", "since", "so that", "than", "though", "till", "unless", "until", "when", "whenever", "where", "whereas", "wherever", "whether", "while", "why", "by the time", "supposing", "no matter", "how", "what", "won't", "do", "does", "–", "and", "but", "or"];
};
//# sourceMappingURL=stopwords.js.map
//# sourceMappingURL=stopwords.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/english/passiveVoice/stopwords.js
// module id = 437
// module chunks = 0